<template>
  <div id="calendar">
    <ul class="calendar-menu">
      <li v-for="(day, index) in days" v-bind:key="index" v-bind:class="{ active: index === active }" v-on:click="active = index">
        {{day.name}}
      </li>
    </ul>
    <div class="calendar-wrapper">
      <div class="calendar-days" v-bind:style="{ }">
        <div class="calendar-day" v-for="(day, index) in days" v-bind:key="index" v-if="day.valid" v-bind:class="{ active: index === active}" v-bind:style="{ height: (getEnd(day.start, day.end) + 20) * step + 'px' }">
          <div class="calendar-hours">
            <div class="calendar-hour" v-for="(hour, index) in day.hours" v-bind:key="index" v-bind:style="{ height: 30 * step + 'px' }">
              <span>{{getTime(hour)}}</span>
            </div>
          </div>
          <div class="calendar-rows">
            <div class="calendar-rows-wrapper">
              <div class="calendar-row" v-for="(row, index) in day.rows" v-bind:key="index">
                <div class="calendar-event" v-for="(event, index) in row" v-on:click="goTo(event.url)" v-bind:key="index" v-bind:style="{ 'background-color': event.color, top: getStart(day.start, event.start) * step + 'px', height: (getEnd(day.start, event.end) - getStart(day.start, event.start)) * step + 'px' }">
                  <span class="calendar-category">{{event.category}}</span>
                  <span class="calendar-title">{{event.title}}</span>
                  <span class="calendar-description">{{event.name}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="calendar-day" v-bind:class="{ active: index === active}" v-else>
          Events data is invalid
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let days = (((window || {}).Drupal || {}).settings || {}).api_events || []

if (process.env.NODE_ENV !== 'production') {
  days = require('./events.json')
}

const daterange = require('daterange')
const prepareRows = events => {
  let rows = [[], [], [], [], [], [], [], [], [], [], [], [], []]
  events.forEach(event => {
    if (!eventOverlap(rows[0], event)) rows[0].push(event)
    else if (!eventOverlap(rows[1], event)) rows[1].push(event)
    else if (!eventOverlap(rows[2], event)) rows[2].push(event)
    else if (!eventOverlap(rows[3], event)) rows[3].push(event)
    else if (!eventOverlap(rows[4], event)) rows[4].push(event)
    else if (!eventOverlap(rows[5], event)) rows[5].push(event)
    else if (!eventOverlap(rows[6], event)) rows[6].push(event)
    else if (!eventOverlap(rows[7], event)) rows[7].push(event)
    else if (!eventOverlap(rows[8], event)) rows[8].push(event)
    else if (!eventOverlap(rows[9], event)) rows[9].push(event)
    else if (!eventOverlap(rows[10], event)) rows[10].push(event)
    else if (!eventOverlap(rows[11], event)) rows[11].push(event)
  })
  return rows
}
const eventOverlap = (events, newEvent) => {
  const newEventRange = daterange.create(
    new Date(newEvent.start),
    new Date(newEvent.end)
  )
  for (let event of events) {
    const eventRange = daterange.create(
      new Date(event.start),
      new Date(event.end)
    )
    if (daterange.overlaps(eventRange, newEventRange)) {
      return true
      break
    }
  }
  return false
}

// let deyz = days.map(obj => ({
//   name: Object.keys(obj)[0],
//   events: obj[Object.keys(obj)[0]],
//   rows: prepareRows(obj[Object.keys(obj)[0]])
// }))

const getMinDate = events => {
  let dates = events.map(event => new Date(event.start))
  let min = dates.reduce(function(a, b) {
    return a < b ? a : b
  })
  return +min
}
const getMaxDate = events => {
  let dates = events.map(event => new Date(event.end))
  let max = dates.reduce(function(a, b) {
    return a > b ? a : b
  })
  return +max
}
function getDates(d1, d2) {
  var step = 1000 * 60 * 30
  for (var d = [], ms = d1 * 1, last = d2 * 1; ms < last; ms += step) {
    d.push(new Date(ms))
  }
  return d
}

function addZero(i) {
  if (i < 10) {
    i = '0' + i
  }
  return i
}

function dayOfYear(d) {
  let date = new Date(d)
  return (
    (Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) -
      Date.UTC(date.getFullYear(), 0, 0)) /
    24 /
    60 /
    60 /
    1000
  )
}

function checkDates(events) {
  let valid = true
  let start_dates = events.map(event => event.start)
  let end_dates = events.map(event => event.end)
  let dates = [...start_dates, ...end_dates]
  if (!dates[0] || !isDate(dates[0])) valid = false
  else {
    let firstDay = dayOfYear(dates[0])
    dates.forEach(val => {
      // console.log(dayOfYear(val), firstDay)
      if (!isDate(val)) valid = false
      else if (dayOfYear(val) !== firstDay) valid = false
    })
  }
  return valid
}

function isDate(date) {
  let d = new Date(date)
  if (Object.prototype.toString.call(d) === '[object Date]') {
    if (isNaN(d.getTime())) {
      return false
    } else {
      return true
    }
  } else {
    return false
  }
}

export default {
  data() {
    return {
      active: 0,
      step: 3,
      days: days.map(obj => ({
        name: Object.keys(obj)[0],
        rows: prepareRows(obj[Object.keys(obj)[0]]),
        start: getMinDate(obj[Object.keys(obj)[0]]),
        end: getMaxDate(obj[Object.keys(obj)[0]]),
        hours: getDates(
          getMinDate(obj[Object.keys(obj)[0]]),
          getMaxDate(obj[Object.keys(obj)[0]])
        ),
        valid: checkDates(obj[Object.keys(obj)[0]])
      }))
    }
  },
  methods: {
    getStart: (dayStart, eventStart) => {
      return (+new Date(eventStart) - +new Date(dayStart)) / 1000 / 60
    },
    getEnd: (dayStart, eventEnd) => {
      return (+new Date(eventEnd) - +new Date(dayStart)) / 1000 / 60
    },
    getTime: d => {
      return addZero(d.getHours()) + ':' + addZero(d.getMinutes())
    },
    goTo: url => {
      window.location.href = url
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue